import { Trans, useTranslation } from 'next-i18next';
import { INTRO_BOARD_IMAGE, SECTION_PADDING } from '../constants';
export function BoardLandingIntro() {
  const {
    t
  } = useTranslation(['boardLanding']);
  return <section aria-labelledby="board-landing-intro-heading" className={`flex flex-col items-center gap-md ${SECTION_PADDING}`} data-sentry-component="BoardLandingIntro" data-sentry-source-file="BoardLandingIntro.tsx">
      <img src={INTRO_BOARD_IMAGE} alt="" width={112} height={81} loading="lazy" className="h-auto w-[112px]" />

      {/*
        Samples·Features·Faq·BottomCta 는 전 구간 display-sm-extrabold 지만
        Intro 만 1025px 미만에서 한 단계 작다(heading-xl-extrabold) — Figma
        모바일 프레임(25561:22588, "Introduction - title")의 제목 줄높이가
        24px 다운스케일과 일치해 의도된 차이다.
       */}
      <h2 id="board-landing-intro-heading" className="text-center text-heading-xl-extrabold text-default min-[1025px]:text-display-sm-extrabold">
        <Trans t={t} i18nKey="boardLanding:intro.title" components={{
        Strong: <strong className="text-strong" />,
        Br: <br className="min-[751px]:hidden" />
      }} data-sentry-element="Trans" data-sentry-source-file="BoardLandingIntro.tsx" />
      </h2>

      <p className="text-center text-body-lg-medium text-neutral">
        <Trans t={t} i18nKey="boardLanding:intro.description" components={{
        Br: <br className="min-[751px]:hidden" />
      }} data-sentry-element="Trans" data-sentry-source-file="BoardLandingIntro.tsx" />
      </p>
    </section>;
}